module.exports = __webpack_public_path__ + "img/Angiogenesis-MELA_GSE185386.4f39de79.png";